import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component, EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { Appointment } from '../../../landing/models';
import { LandingPageService } from '../../../services/landing-page.service';
import * as moment from 'moment';
import { Globals } from '../../../globals';
import { HomeAccordionService } from '../controls/home-accordion/home-accordion.service';
import { Subscription } from 'rxjs';
import { MessagingService } from '../../../services/messaging.service';
import { CommMethodEnum } from '../../../models/enum/comm-method.enum';
import { MessagingConstants } from '../../../models/MessagingConstants';
import { PatientService } from '../../../modules/patient/patient.service';
import { PatientDataModel } from '../../../models/patient/patient-data.model';
import { LocalStorageService } from '../../../services/local-storage.service';
import { FileManagerService } from '../../../modules/file-manager/file-manager.service';
import { DocumentDataModel } from '../../../models/document/document-data.model';
import { SignalrService } from 'src/app/services/socket/signalr.service';
import {UiService} from '../../../services/ui.service';

@Component({
  selector: 'app-recent-patients',
  templateUrl: './recent-patients.component.html',
  styleUrls: ['./recent-patients.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecentPatientsComponent implements OnInit, OnDestroy, OnChanges {
  @Input() recentPatients: PatientDataModel[] = [];
  @Input() isOpen: boolean = false;

  @Output() requestClose = new EventEmitter();
  // this is for the schedule section on the top left
  // it's suppose to default at today and can only go in the future
  currAndFutureAppointments: Appointment[] = [];
  // this is for the recent patients, it starts at yesterday only goes back in time
  pastAppointments: Appointment[] = [];
  selectedAppointmentId: string;

  recentPatientRange: string = '';

  apptPageSize: number = 10;
  apptPageIndex: number = 0;

  scheduleDate: moment.Moment;
  today: moment.Moment = moment();
  isLoading: boolean = true;

  //dataSub: Subscription;


  constructor(private landingPageService: LandingPageService,
    private fileService: FileManagerService,
    public patientService: PatientService,
    private globals: Globals,
    private homeAccordionService: HomeAccordionService,
    private localStorageService: LocalStorageService,
    private cd: ChangeDetectorRef,
    private messagingService: MessagingService,
    private uiService: UiService,
    private signalrService: SignalrService) { }

  ngOnInit(): void {
    // Initialize with current data if available
    this.recentPatients = [...this.patientService.recentPatients];

    // Listen for patient deleted messages
    this.messagingService.componentMessageCall.subscribe(response => {
      if (response.event === 'PATIENT_DELETED') {
        // If we know which patient was deleted, we can manually filter it out for immediate UI update
        if (response.data && response.data.patientId) {
          this.recentPatients = this.recentPatients.filter(
            patient => patient.PatientId !== response.data.patientId
          );
          this.cd.markForCheck();
          this.cd.detectChanges();
        }
      }
    });

    this.signalrService.messageUser.subscribe((res) => {
      if (res.messageType === 'UPDATE_PATIENT_PICTURE') {
      if (res.message && res.message['patientId'] && res.message['patientId'] === this.globals.currentPatientId) {
        this.fileService.getPatientPictureClearCache(this.globals.currentPatientId).subscribe((res2) => {
        this.fileService.getPatientPicture(this.globals.currentPatientId + '?' + new Date().toString()).subscribe((res) => {
          if (res) {
          const patient = this.recentPatients.find(x => x.PatientId === this.globals.currentPatientId);
          if (patient) {
            patient.patientImageUrl = this.fileService.getDocumentUrlFromDocument(res);
            this.cd.detectChanges();
          }
          } else {
          const patient = this.recentPatients.find(x => x.PatientId === this.globals.currentPatientId);
          if (patient) {
            patient.patientImageUrl = 'assets/Images/defaultPatient.PNG';
            this.cd.detectChanges();
          }
          }
        });
        });
      } else {
        const patient = this.recentPatients.find(x => x.PatientId === this.globals.currentPatientId);
        if (patient) {
        patient.patientImageUrl = 'assets/Images/defaultPatient.PNG';
        this.cd.detectChanges();
        }
      }
      }
    });

  }

  ngOnChanges(changes: SimpleChanges) {
    // Only refresh when the panel is opened
    if (changes.isOpen && changes.isOpen.currentValue === true) {
      this.isLoading = true;
      this.patientService.getRecentPatients(this.localStorageService.currentUserData.authdata.userid).subscribe(() => {
        this.recentPatients = [...this.patientService.recentPatients];
        this.isLoading = false;
        this.cd.markForCheck();
        this.cd.detectChanges();
      });
    }
  }

  ngOnDestroy(): void {

  }

  changePatient(patient: PatientDataModel) {
    this.messagingService.broadCastMessage(MessagingConstants.PATIENT_CHANGED, {
      PatientID: patient.PatientId,
      PatientName: patient.dataContact.FirstName + ' ' + patient.dataContact.MidName + ' ' + patient.dataContact.LastName,
      clearCurrentQuery: false
    });
    this.uiService.handlePatientSwitchImagingWindow();

    this.requestClose.emit();
  }

  changePatientRange(isIncrementing: boolean) {
    this.homeAccordionService.changeRecentPatients(isIncrementing);
  }

  getContact(appointment: PatientDataModel) {
    let comm = appointment.dataContact.dataContactComms.find(p => p.isPreferred === true);
    if (!comm) {
      if (appointment.dataContact.dataContactComms.length > 0) {
        comm = appointment.dataContact.dataContactComms.find(p => p.enumCommMethodID === CommMethodEnum.Mobile);
        if (comm) {
          return comm.Address;
        } else {
          comm = appointment.dataContact.dataContactComms.find(p => p.enumCommMethodID === CommMethodEnum.Email);
          if (comm) {
            return comm.Address;
          } else {
            comm = appointment.dataContact.dataContactComms.find(p => p.enumCommMethodID === CommMethodEnum.Phone);
            if (comm) {
              return comm.Address;
            } else {
              return 'No contact data found.';
            }
          }
        }
      } else {
        return '';
      }
    }
    return comm.Address;
  }

  getAddress(appointment: PatientDataModel) {
    if (appointment.dataContact.dataAddresses.length === 0) {
      return 'No address information';
    }

    // TODO: Adjust the query to not lazy load dataAddress and to filter out xauditDeleted on the backend.
    const comm = appointment.dataContact.dataAddresses.find(p => p.Address1 && !p.xauditDeleted);
    if (comm) {
      if (comm.Address1 && comm.Address1.length > 0) {
        return comm.Address1;
      }
    }

    return 'No address information';
  }

  getName(appt: PatientDataModel) {
    let str = '';
    str += appt.dataContact.FirstName;
    if (appt.dataContact.MidName) {
      str += ' ' + appt.dataContact?.MidName;
    }
    str += ' ' + appt.dataContact.LastName;

    return str;
  }

  async getPatientPicture(appt: PatientDataModel) {
    const res: DocumentDataModel = await this.fileService.getPatientPicture(appt.PatientId).toPromise();
    let url = 'assets/Images/defaultPatient.PNG';
    if (res) {
      url = this.fileService.getDocumentUrlFromDocument(res);
    }
    return url;
  }
}
